module.exports = __webpack_public_path__ + "img/login-v2-dark.b18b5364.svg";